export var PhotoCaptureAssignmentTypes;
(function (PhotoCaptureAssignmentTypes) {
    PhotoCaptureAssignmentTypes["CONSUMER_PHOTO_CAPTURE"] = "PHOTO_CAPTURE";
    PhotoCaptureAssignmentTypes["PHOTO_CAPTURE"] = "PHOTO_CAPTURE";
    PhotoCaptureAssignmentTypes["REQ_ADDITIONAL_PHOTO"] = "REQ_ADDITIONAL_PHOTO";
    PhotoCaptureAssignmentTypes["GENRIC_PHOTO_CAPTURE"] = "GENRIC_PHOTO_CAPTURE";
})(PhotoCaptureAssignmentTypes || (PhotoCaptureAssignmentTypes = {}));
//# sourceMappingURL=PhotoCaptureAssignmentTypes.js.map